import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import parse from 'html-react-parser'
import currencyFormatter  from 'currency-formatter'

import Link from '../link/link'

const ContentHome = ({ isHome, relativelink, title, home, featuredImage }) => {
	if(!home){
		return <></>
	}
	return (
		<Link to={`${relativelink}`} className={`${isHome ? 'h-full': ''} border border-tan-500 hover:border-tan-300 bg-white w-full mb-6 relative flex flex-wrap`}>
			{
				(home?.isNew || home?.financeAvailable || home?.comingSoon) &&
				<div className="absolute top-0 left-0 z-20 p-2">
					{
						home?.isNew &&
						<div>
							<div className="bg-tan-100 text-tan-700 px-3 py-1 text-xs rounded-full font-semibold inline-block mr-1 mb-1">
							New
							</div>
						</div>
					}
					{
						home?.financeAvailable &&
						<div>
							<div className="bg-tan-800 text-white px-3 py-1 text-xs rounded-full font-semibold inline-block mr-1 mb-1">
							Finance available
							</div>
						</div>
					}
					{
						home?.comingSoon &&
						<div>
							<div className="bg-tan-200 text-tan-700 px-3 py-1 text-xs rounded-full font-semibold inline-block mr-1 mb-1">
							Coming soon
							</div>
						</div>
					}
				</div>
			}

			<div className={`w-full ${isHome ? '': 'sm:w-1/3 lg:w-1/4'} relative overflow-hidden`}>
			{
				featuredImage && featuredImage?.node?.localFile?.childImageSharp &&
				<GatsbyImage className="w-full h-full object-cover object-center" image={featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData} alt={featuredImage?.node?.altText || ''} />
			}
			{
				featuredImage && !featuredImage?.node?.localFile?.childImageSharp &&
				<img src={featuredImage.node.sourceUrl} className="w-full h-full object-cover object-center" alt={featuredImage?.node?.altText || ''} />
			}
			</div>
			<div className={`p-3 lg:p-5 flex-1 w-auto flex flex-col`}>

				<div className="flex flex-wrap justify-center sm:justify-start space-x-3 items-center mb-2">
					<div className="font-bold text-white bg-tan-700 px-3 py-1 rounded-full text-xs">
						{ home?.year }
					</div>

					<div className="font-bold text-white bg-tan-700 px-3 py-1 rounded-full text-xs">
						{ home?.propertyType === 'pre-owned' ? 'Pre-owned' : 'New' }
					</div>
					{
						home?.onPlot &&
						<div className="font-bold text-white bg-tan-700 px-3 py-1 rounded-full text-xs">
							On plot
						</div>
					}


					{
						home?.holidayPark &&
						<div className="flex items-center text-sm">
							<svg className="w-5 h-5 text-tan-500 fill-current" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
								<path d="M41 19.2911C41 26.283 36.8013 32.9432 32.7663 37.7561C30.7312 40.1835 28.6988 42.1868 27.1758 43.5831C26.1519 44.5218 25.0945 45.4144 23.9992 46.2681C22.9044 45.4126 21.8472 44.5183 20.8236 43.5782C19.3007 42.1795 17.2684 40.1734 15.2334 37.7441C11.199 32.928 7 26.2677 7 19.2911C7 8.27286 15.7316 2 24 2C32.2684 2 41 8.27286 41 19.2911ZM24 13C20.6863 13 18 15.6863 18 19C18 22.3137 20.6863 25 24 25C27.3137 25 30 22.3137 30 19C30 15.6863 27.3137 13 24 13Z" fillRule="evenodd"/>
							</svg>
							<span className="ml-1">{ parse(home?.holidayPark?.title || '')}</span>
						</div>
					}


				</div>

				<div className="flex flex-wrap sm:flex-nowrap sm:space-x-3 justify-between mb-2 text-center sm:text-left">
					<div className="w-full sm:w-auto font-serif">{ parse(title) }</div>
					<div className='w-full sm:w-auto text-center sm:text-right'>
						<div className={`inline-block mt-2 sm:mt-0 bg-tan-100 rounded-full text-[14px] px-4 py-1 font-bold ${home?.salePriceOld ? 'bg-tan-500 text-white' : 'bg-tan-100 text-tan-700'}`}>
							{ currencyFormatter.format(home?.salePrice, { code: 'GBP', precision: 0 }) }
						</div>
						{
							home?.salePriceOld &&
							<span className="px-4 text-xs line-through">{ currencyFormatter.format(home?.salePriceOld, { code: 'GBP', precision: 0 }) }</span>
						}
					</div>
				</div>
				{
					!isHome &&
					<div className="mb-3 text-sm sm:text-base text-center sm:text-left">
						<div>{ parse(home?.shortDescription) }</div>
					</div>
				}

				<div className="flex flex-wrap space-x-3 items-center justify-center sm:justify-start mt-auto">
					{
						home?.size &&
						<div className="flex items-center text-sm">
							<svg className="w-4 h-4 text-tan-500 fill-current stroke-current" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
							<g strokeLinecap="round" strokeLinejoin="round"> 
								<polyline fill="none" points="19 29 19 3 19 4" strokeWidth="2"/>
								<polyline fill="none" points="24 8 19 3 14 8" strokeWidth="2"/>
								<polyline fill="none" points="4 44 19 29 44 29" strokeWidth="2"/>
							</g>
							</svg>
							<span className="ml-1.5">{ home?.size }</span>
						</div>
					}
					{
						home?.decking &&
						<div className="flex items-center text-sm">
							<svg className="w-4 h-4 text-tan-500 fill-current stroke-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
								<g fill="none">
									<path d="M12 4.44L8.34 7h7.32L12 4.44z" opacity=".3"/>
									<path d="M22 9L12 2 2 9h9v13h2V9h9zM12 4.44L15.66 7H8.34L12 4.44z" />
									<path d="M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9l-.76-4z" />
									<path d="M19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37-.76 4z" />
								</g>
							</svg>
							<span className="ml-1.5">Decking</span>
						</div>
					}
					{
						home?.bedrooms &&
						<div className="flex items-center text-sm">
                          <svg className="w-4 h-4 text-tan-500 fill-current stroke-current" height="36" width="36" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                            <g strokeLinecap="square" strokeWidth="2" transform="translate(0.5 0.5)">
                              <line fill="none" x1="2" x2="2" y1="41" y2="7"/>
                              <line fill="none" x1="46" x2="46" y1="41" y2="27"/>
                              <line fill="none" x1="2" x2="46" y1="35" y2="35"/>
                              <line fill="none" x1="2" x2="46" y1="27" y2="27"/>
                              <circle cx="11" cy="18" fill="none" r="4"/>
                              <path d="M20,15H42a4,4,0,0,1,4,4v3a0,0,0,0,1,0,0H20a0,0,0,0,1,0,0V15A0,0,0,0,1,20,15Z" fill="none"/>
                            </g>
                          </svg>
							<span className="ml-1.5">{home?.bedrooms}</span>
						</div>
					}
					{
						home?.sleeps &&
						<div className="flex items-center text-sm">
                          <svg className="w-4 h-4 text-tan-500 fill-current stroke-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
								<g strokeLinecap="round" strokeLinejoin="round">
									<path d="M16 8C14.342 8 13 6.658 13 5C13 3.342 14.342 2 16 2C17.658 2 19 3.342 19 5C19 6.658 17.658 8 16 8Z" fill="none" strokeWidth="1.5"/>
									<path d="M25 8C23.8947 8 23 7.10533 23 6C23 4.89467 23.8947 4 25 4C26.1053 4 27 4.89467 27 6C27 7.10533 26.1053 8 25 8Z" fill="none" strokeWidth="1.5"/>
									<path d="M7 8C8.10533 8 9 7.10533 9 6C9 4.89467 8.10533 4 7 4C5.89467 4 5 4.89467 5 6C5 7.10533 5.89467 8 7 8Z" fill="none" strokeWidth="1.5"/>
									<path d="M19 30H13L11.9 21L9.49976 19.75L10.4875 13.575C10.6303 12.6838 11.2171 11.94 12.0332 11.6337C12.9225 11.3 14.6025 11 16.0006 11C16.6967 11 18.4595 11.075 19.9237 11.6175C20.753 11.925 21.3674 12.6713 21.5114 13.575L22.4991 19.75L20.0989 21L19 30Z" fill="none" strokeWidth="1.5"/>
									<path d="M26 11C26.4872 11 27.3388 11.0637 28.3637 11.5249C28.9442 11.7862 29.3743 12.4206 29.4751 13.1888L30.1665 18.9375L28.4864 20L27.5 28H25" fill="none" strokeWidth="1.5"/>
									<path d="M6 11C5.51277 11 4.66117 11.0637 3.63632 11.5249C3.05585 11.7862 2.62574 12.4206 2.52494 13.1888L1.83354 18.9375L3.51363 20L4.5 28H7" fill="none" strokeWidth="1.5"/>
									<path d="M6 11C5.51277 11 4.66117 11.0637 3.63632 11.5249C3.05585 11.7862 2.62574 12.4206 2.52494 13.1888L1.83354 18.9375L3.51363 20L4.5 28H7" fill="none" strokeWidth="1.5"/>
								</g>
							</svg>
							<span className="ml-1.5">{home?.sleeps}</span>
						</div>
					}




				</div>
			</div>
		</Link>


	)
}



export default ContentHome;
